// AI Optimize — uses the buyer's Groq API key (from Settings) for AI suggestions.
// The PWA works fully without this; the key is optional.

import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiOptimizeDay(
  tasks: any[],
  onStream: (chunk: string) => void
): Promise<void> {
  const system = `You are a productivity coach using Eisenhower Matrix + RICE + energy management. Analyze these prioritized tasks and suggest: 1) Task decomposition for items >4 hours, 2) Energy-level matching (high energy = morning), 3) Batching similar tasks, 4) What to delegate or eliminate. Keep suggestions actionable and specific. Use Markdown.`;
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: `Tasks: ${JSON.stringify(tasks.slice(0, 10))}` },
      ],
      temperature: 0.4,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The core logic above works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
